import React, { useCallback, useLayoutEffect, useRef } from 'react';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { Editor } from 'react-draft-wysiwyg';
import SwagBlueLogoPath from 'assets/img/swag-logo-blue.jpg';
import cs from 'classnames';
import classNames from 'classnames';
import { CUSTOM_FONT_SIZE_STYLE_MAP } from '../constants';
import classes from './notecard-text-editor.scss';
export const NotecardTextEditor = ({
  logo,
  color,
  editorState: editorStateProp,
  updateEditorRawContent,
  setEditorState,
  isInputValid,
  setIsInputValid,
  editorRef,
  wrapperRef,
  className
}) => {
  const containerRef = useRef(null);
  const contentRef = useRef(null);
  const doesInputExceedLimit = useCallback(() => {
    if (!containerRef.current) {
      var _wrapperRef$current, _wrapperRef$current$q;
      const wrapperNode = (_wrapperRef$current = wrapperRef.current) === null || _wrapperRef$current === void 0 ? void 0 : (_wrapperRef$current$q = _wrapperRef$current.querySelector) === null || _wrapperRef$current$q === void 0 ? void 0 : _wrapperRef$current$q.call(_wrapperRef$current, '.notecard-editor-container');
      if (!wrapperNode) {
        return false;
      }
      containerRef.current = wrapperNode;
    }
    if (!contentRef.current) {
      var _wrapperRef$current2, _wrapperRef$current2$;
      const contentNode = (_wrapperRef$current2 = wrapperRef.current) === null || _wrapperRef$current2 === void 0 ? void 0 : (_wrapperRef$current2$ = _wrapperRef$current2.querySelector) === null || _wrapperRef$current2$ === void 0 ? void 0 : _wrapperRef$current2$.call(_wrapperRef$current2, '.public-DraftEditor-content > div');
      if (!contentNode) {
        return false;
      }
      contentRef.current = contentNode;
    }
    return contentRef.current.clientHeight > containerRef.current.clientHeight - 30;
  }, [editorStateProp]);
  useLayoutEffect(() => {
    setTimeout(() => {
      const isInputValidNew = !doesInputExceedLimit();
      isInputValidNew !== isInputValid && setIsInputValid(isInputValidNew);
    }, 0);
  }, [doesInputExceedLimit]);
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(classes.container, className),
    style: {
      borderColor: color
    },
    ref: wrapperRef
  }, logo && /*#__PURE__*/React.createElement("img", {
    className: classes.logo,
    src: logo || SwagBlueLogoPath,
    alt: "Swag logo"
  }), /*#__PURE__*/React.createElement("div", {
    className: cs(classes.editorWrapper, {
      [classes.emptyLogoOffset]: !logo
    })
  }, !isInputValid && /*#__PURE__*/React.createElement("p", {
    className: classes.validationMessage
  }, "Please edit your message to fit into the available space"), /*#__PURE__*/React.createElement("div", {
    className: cs('notecard-editor-container', {
      [classes.validationError]: !isInputValid
    })
  }, /*#__PURE__*/React.createElement(Editor, {
    ref: editorRef,
    toolbarHidden: true,
    onBlur: updateEditorRawContent,
    editorState: editorStateProp,
    onEditorStateChange: setEditorState,
    customStyleMap: CUSTOM_FONT_SIZE_STYLE_MAP
  }))));
};